import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

import { AppForm } from 'src/app/models/app-form';
import { ApiService } from 'src/app/services/api.service';
import { AppService } from 'src/app/services/app.service';

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements OnInit, OnDestroy {

  //-- VARIABLES -------------------------------------------------------|

  form: FormGroup; 
  public submitted: boolean;
  public firstSubmitted: boolean;
  public loading: boolean;
  public isProduction: boolean = false;
  public initLoading: boolean = true;
  showTerms: boolean = false;

  private $loadingStatus: Subscription;

  //-- CONSTRUCTOR -----------------------------------------------------|

  constructor(private apiService: ApiService, private appService: AppService, private fb: FormBuilder) {
    this.$loadingStatus = this.appService.$loadingStatus.subscribe(data => { this.initLoading = data });
  }

  //-- EVENTS ----------------------------------------------------------|
  onSubmit() {
    this.firstSubmitted = true;
    this.submitted = true;
    this.loading = true;

    if (this.form.valid) {
      const { cardNumber, mpId } = this.form.value;
      this.apiService.memberPromotion(mpId, cardNumber);
    } else {
      this.loading = false;
      this.submitted = false;
      var formControls = Object.keys(this.form.controls);
      for(let i = 0; i < formControls.length; i++) {
        
        if (this.form.controls[formControls[i]].invalid) {
          const invalidElement = document.querySelector(`[formControlName="${formControls[i]}"]`) as HTMLElement;
          if (invalidElement) {
            invalidElement.focus()
          }
          break;
        }
      }
    }
  }

  showFormError(){
    return (this.firstSubmitted && (this.form.invalid))
  }

  onCloseTerms() {
    this.showTerms = false;
  }
  
  onKeydown(event: any){
    if(event.key === 'Enter'){
        this.showTerms = !this.showTerms;
    }
  }

  //-- INITIALIZE ------------------------------------------------------|

  ngOnInit() {
    setTimeout(() => { this.initLoading = this.appService.getLoadingStatus(); }, 2000);
    this.form = this.fb.group({
      cardNumber: ['', Validators.required],
      mpId: ['', Validators.required]
    });
  }

  //-- DESTORY ---------------------------------------------------------|

  ngOnDestroy() {
    if (this.$loadingStatus) { this.$loadingStatus.unsubscribe(); }
  }

  //--------------------------------------------------------------------|







}

